import state from './scanresult.state'
import mutations from './scanresult.mutations'
import actions from './scanresult.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
